import { render, staticRenderFns } from "./Contractor.vue?vue&type=template&id=45831956&scoped=true"
import script from "./Contractor.vue?vue&type=script&lang=ts"
export * from "./Contractor.vue?vue&type=script&lang=ts"
import style0 from "./Contractor.vue?vue&type=style&index=0&id=45831956&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45831956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45831956')) {
      api.createRecord('45831956', component.options)
    } else {
      api.reload('45831956', component.options)
    }
    module.hot.accept("./Contractor.vue?vue&type=template&id=45831956&scoped=true", function () {
      api.rerender('45831956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/Contractor.vue"
export default component.exports